import { render, staticRenderFns } from "./NewCustomerForm.vue?vue&type=template&id=45347b69&"
import script from "./NewCustomerForm.vue?vue&type=script&lang=ts&"
export * from "./NewCustomerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports